import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ThemeCustomizer from '../../components/admin/ThemeCustomizer';
import { useAuth } from '../../lib/auth';
import { useThemeStore } from '../../lib/theme';
import type { AgencyTheme } from '../../types';

export default function ThemePage() {
  const { user } = useAuth();
  const { getTheme, setTheme } = useThemeStore();
  const [currentTheme, setCurrentTheme] = React.useState<AgencyTheme>(
    getTheme(user?.agencyId || '')
  );

  const handleSave = () => {
    if (user?.agencyId) {
      setTheme(user.agencyId, currentTheme);
      alert('Thème sauvegardé avec succès !');
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold">Personnalisation du site</h1>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Enregistrer les modifications
          </button>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <ThemeCustomizer theme={currentTheme} onChange={setCurrentTheme} />
        </div>
      </div>
    </AdminLayout>
  );
}